<template>
	<div>
		<card>
			<template slot="header">
				<h5 v-if="$slots.title || title" class="card-title">
					<slot name="title">
						{{title}}
					</slot>
				</h5>
			</template>
			<div>
				<div class="loading-spinner" v-if="isLoading">
					<vue-loaders-line-spin-fade-loader class="loading" color="white" scale="1.4"/>
				</div>
				<div class="container-fluid" v-else>
					<div class="row pt-2" v-if="!!weatherData">
						<div class="col-xl-2 text-center mb-2">
							<label for="weather" class="w-title"> Weather</label>
							<label id="weather" class="w-value"> {{ weatherData.current.weather_descriptions[0] }} </label>
						</div>
						<div class="col-xl-2 text-center mb-2">
							<label for="feelslike" class="w-title">Temperature</label>
							<label id="feelslike" class="w-value"> {{ weatherData.current.temperature }} °C </label>
						</div>
						<div class="col-xl-2 text-center mb-2">
							<label for="pressure" class="w-title"> Pressure</label>
							<label id="pressure" class="w-value"> {{ weatherData.current.pressure }} Pa</label>
						</div>
						<div class="col-xl-2 text-center mb-2">
							<label for="wind_speed" class="w-title"> Wind speed</label>
							<label id="wind_speed" class="w-value"> {{ weatherData.current.wind_speed }} m/s</label>
						</div>
						<div class="col-xl-2 text-center mb-2">
							<label for="wind_degree" class="w-title"> Wind Degree</label>
							<label id="wind_degree" class="w-value"> {{ weatherData.current.wind_degree }} °</label>
						</div>
						<div class="col-xl-2 text-center mb-2">
							<label for="visibility" class="w-title"> Visibility</label>
							<label id="visibility" class="w-value"> {{ weatherData.current.visibility }} </label>
						</div>
						<div class="col-xl-2 text-center mb-2">
							<label for="humidity" class="w-title"> Humidity</label>
							<label id="humidity" class="w-value"> {{ weatherData.current.humidity }} </label>
						</div>
						<div class="col-xl-2 text-center mb-2">
							<label for="sun_rise" class="w-title"> Sun Rise</label>
							<label id="sun_rise" class="w-value"> {{ weatherData.historical[requestDay].astro.sunrise }} </label>
						</div>
						<div class="col-xl-2 text-center mb-2">
							<label for="sun_set" class="w-title"> Sun Set</label>
							<label id="sun_set" class="w-value"> {{ weatherData.historical[requestDay].astro.sunset }} </label>
						</div>
<!--						<div class="col-xl-2 text-center mb-2">-->
<!--							<label for="predict_sun_rise" class="w-title"> Forecast Sun Rise</label>-->
<!--							<label id="predict_sun_rise" class="w-value"> {{ weatherData.historical[requestDay].astro.sunrise }} </label>-->
<!--						</div>-->
<!--						<div class="col-xl-2 text-center mb-2">-->
<!--							<label for="predict_sun_set" class="w-title"> Forecast Sun Set</label>-->
<!--							<label id="predict_sun_set" class="w-value"> {{ weatherData.historical[requestDay].astro.sunset }} </label>-->
<!--						</div>-->
					</div>
					<div class="row pt-5 pb-0 mb-0">
						<div class="col-xl-6 col-xs-12">
							<date-picker class="inline-block h-full text-center" @input="onDateRangeChange" v-model="pickedDateRange" :attributes ="attrs" is-range>
								<template v-slot="{ inputValue, togglePopover }">
									<div class="flex items-center"  style="display:flex;">
										<button
											class="timepickerbutton"
											@click="togglePopover()"
										>
											<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar" viewBox="0 0 16 16">
												<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
											</svg>
										</button>
										<input
											:value="getValueTime(inputValue)"
											class="display-time"
											readonly
										/>
									</div>
								</template>
							</date-picker>
						</div>
						<div class="col-xl-6 col-xs-12 text-center">
							<button type="button" class="filter-action " @click="downloadCSV">Download CSV</button>
						</div>
					</div>
					<div class="row pt-2 pb-3">
						<div class="col-lg-4 col-sm-6 col-xs-12 graph-panel" @click="openZoomDialog('temperature')">
							<v-chart class="chart" :option="temperatureOption" ref="temperatureChart"/>
						</div>
						<div class="col-lg-4 col-sm-6 col-xs-12 graph-panel" @click="openZoomDialog('humidity')">
							<v-chart class="chart" :option="humidityOption" ref="humidityChart"/>
						</div>
						<div class="col-lg-4 col-sm-6 col-xs-12 graph-panel" @click="openZoomDialog('light')">
							<v-chart class="chart" :option="lightOption" ref="lightChart"/>
						</div>
					</div>
					<div class="row pt-2 pb-3">
						<div class="col-xl-12 image-wrapper" @click="testGraph">
								<v-chart class="sensor-chart" :option="sensorOption" autoresize />
						</div>
					</div>
				</div>
			</div>
		</card>
		<vue-modaltor :visible="showModal" :close-scroll="true">
			<template #header>
				<div>
					<i class="close-icon" @click="showModal=false">x</i>
				</div>
			</template>
			<template #body>
				<div class="container-fluid">
					<div class="row pt-2 pb-5 pl-3 pr-3">
						<div class="col-xl-12">
							<v-chart class="zoomChart" :option="zoomOption" autoresize/>
						</div>
					</div>
				</div>
			</template>
		</vue-modaltor>
	</div>
</template>
<script>

import Card from "./Card.vue";
import { mapActions, mapGetters } from "vuex";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart } from "echarts/charts";
import { ScatterChart } from "echarts/charts";
import {
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	GridComponent
} from "echarts/components";
import VChart  from "vue-echarts";
import QuerySetting from '@/mixins/querySetting';
import {saveAs} from "file-saver";
import axios from 'axios';

use([
	CanvasRenderer,
	ScatterChart,
	LineChart,
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	GridComponent
]);
export default {
	name: "environment",
	mixins: [QuerySetting],
	props: {
		title: {
			type: String,
			default: ""
		}
	},
	components: {
		Card,
		VChart
	},
	computed: {
		...mapGetters({
			periodTime: 'settime/getPeriodTime',
			defaultSiteId: 'auth/getDefaultSiteId'
		})
	},
	data() {
		let vm = this;
		return {
			isLoading: false,
			showModal: false,
			temperatureData: [],
			humidityData: [],
			lightData: [],
			weatherData: null,
			pickedDateRange: null,
			attrs: [
				{
					key: 'today',
    				highlight: true,
					dates: new Date(),
				}
			],
			sensorOption: {
				tooltip: {
					position: 'top',
					backgroundColor: "#484E69",
					borderColor: "#484E69",
					axisPointer: {
						type: "shadow",
					},
					textStyle: {
						color: 'white'
					},
					formatter: function(params) {
						let humi = params.data.humi;
						let temp = params.data.temp;
						let light = params.data.light;
						let name = params.data.name;
						vm.changeLegendSelection(params.data)
						return `Location: ${name}<br/>Temperature: ${temp} °C<br/>Humidity: ${humi} %<br/>Light: ${light}`;
					}
				},
				xAxis: {
					axisLine: {
						show: false
					},
					splitLine: {
						show: false
					},
					axisLabel: {
						show: false
					},
					axisTick: {
						show: false
					}
				},
				yAxis: {
					axisLine: {
						show: false
					},
					splitLine: {
						show: false
					}
				},
				grid: {
					top: '0%',
					bottom: '0%',
					left: '0%',
					height: '90%',
					width: '100%'
				},
				series: [
					{
						symbol: function(value, params) {
							if(params.data.temp < 21) {
								return 	'image://' + require('../../assets/img/sensors/blue-sensor.png');
							} else if (params.data.temp > 21 && params.data.temp < 23) {
								return 	'image://' + require('../../assets/img/sensors/amber-sensor.png');
							} else {
								return 	'image://' + require('../../assets/img/sensors/red-sensor.png');
							}
						},
						symbolSize: 40,
						symbolKeepAspect: true,
						data: [
							{value: [1.9, 9.4], temp: 0, humi: 0, light: 0},
							{value: [3, 9.4], temp: 0, humi: 0, light: 0},
							{value: [4.2, 9.4], temp: 0, humi: 0, light: 0},
							{value: [5.38, 9.4], temp: 0, humi: 0, light: 0},
							{value: [7.2, 8.6], temp: 0, humi: 0, light: 0},
							{value: [9.4, 9.4], temp: 0, humi: 0, light: 0},
							{value: [1.9, 4.6], temp: 0, humi: 0, light: 0},
							{value: [3.8, 4.6], temp: 0, humi: 0, light: 0},
							{value: [5.7, 4.6], temp: 0, humi: 0, light: 0},
							{value: [0.3, 0.24], temp: 0, humi: 0, light: 0},
							{value: [1, 0.24], temp: 0, humi: 0, light: 0},
							{value: [1.86, 0.24], temp: 0, humi: 0, light: 0},
							{value: [3.5, 0.24], temp: 0, humi: 0, light: 0},
							{value: [5.66, 0.24], temp: 0, humi: 0, light: 0},
							{value: [6.14, 0.24], temp: 0, humi: 0, light: 0},
							{value: [8.2, 0.54], temp: 0, humi: 0, light: 0},
							{value: [8.43, 0.34], temp: 0, humi: 0, light: 0},
							{value: [9.9, 0.54], temp: 0, humi: 0, light: 0},
						],
						type: 'scatter'
					}
				]
			},
			zoomOption: {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					backgroundColor: "#484E69",
					borderColor: "#484E69",
					textStyle: {
						color: 'white'
					},
				},
				grid: {
					left: '6%',
					bottom: '30%',
					width: '100%',
					height: '60%'
				},
				xAxis: [
					{
						type: 'time',
						axisLabel: {
							show: true,
							rotate: 90,
							textStyle: {
								color: 'white',
								fontSize: '12px',
								fontWeight: 200,
								fontFamily: 'Nunito Sans Light',
							}
						},
						axisLine: {
							lineStyle: {
								type: 'dashed'
							}
						},
						axisTick: {
							show: false
						}
					}
				],
				yAxis: [
					{
						type: 'value',
						show: true,
						nameRotate: 90,
						name: 'Temperature',
						nameLocation: 'middle',
						nameGap: 50,
						axisLabel: {
							show: true,
							color: 'white',
							formatter: `{value} °C`
						},
						splitLine: {
							lineStyle: {
								color: 'rgba(255, 255, 255, 0.3)',
								type: 'dashed',
								width: 1
							}
						},
						splitNumber: 8,
						nameTextStyle: {
							verticalAlign: 'middle',
							color: 'white',
							fontSize: '13px',
							fontFamily: 'Nunito Sans Regular',
							fontWeight: 600,
						}
					}
				],
				legend: {
					bottom: '0',
					borderColor: '#FDFDFD' ,
					borderWidth: 0.5 ,
					borderRadius: 5,
					left: '10%',
					textStyle: {
						color: '#FDFDFD'
					},
					padding: 10,
					selectedMode: true,
					itemWidth: 12,
					itemHeight: 12,
					icon: 'rect'
				},
				series: []
			},
			temperatureOption: {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					backgroundColor: "#484E69",
					borderColor: "#484E69",
					textStyle: {
						color: 'white'
					},
				},
				grid: {
					left: '25%'
				},
				xAxis: [
					{
						type: 'time',
						axisLabel: {
							show: true,
							rotate: 90,
							textStyle: {
								color: 'white',
								fontSize: '12px',
								fontWeight: 200,
								fontFamily: 'Nunito Sans Light',
							}
						},
						axisLine: {
							lineStyle: {
								type: 'dashed'
							}
						},
						axisTick: {
							show: false
						}
					}
				],
				yAxis: [
					{
						type: 'value',
						show: true,
						nameRotate: 90,
						name: 'Temperature',
						nameLocation: 'middle',
						nameGap: 50,
						axisLabel: {
							show: true,
							color: 'white',
							formatter: `{value} °C`
						},
						splitLine: {
							lineStyle: {
								color: 'rgba(255, 255, 255, 0.3)',
								type: 'dashed',
								width: 1
							}
						},
						splitNumber: 8,
						nameTextStyle: {
							verticalAlign: 'middle',
							color: 'white',
							fontSize: '13px',
							fontFamily: 'Nunito Sans Regular',
							fontWeight: 600,
						}
					}
				],
				legend: {
					show: false,
				},
				series: []
			},
			temperatureSeries: [],
			humidityOption: {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					backgroundColor: "#484E69",
					borderColor: "#484E69",
					textStyle: {
						color: 'white'
					},
				},
				grid: {
					left: '25%'
				},
				xAxis: [
					{
						type: 'time',
						axisLabel: {
							show: true,
							rotate: 90,
							textStyle: {
								color: 'white',
								fontSize: '12px',
								fontWeight: 200,
								fontFamily: 'Nunito Sans Light',
							}
						},
						axisLine: {
							lineStyle: {
								type: 'dashed'
							}
						},
						axisTick: {
							show: false
						}
					}
				],
				yAxis: [
					{
						type: 'value',
						show: true,
						nameRotate: 90,
						name: 'Humidity',
						nameLocation: 'middle',
						nameGap: 50,
						axisLabel: {
							show: true,
							color: 'white',
							formatter: `{value} %`
						},
						splitLine: {
							lineStyle: {
								color: 'rgba(255, 255, 255, 0.3)',
								type: 'dashed',
								width: 1
							}
						},
						splitNumber: 8,
						nameTextStyle: {
							verticalAlign: 'middle',
							color: 'white',
							fontSize: '13px',
							fontFamily: 'Nunito Sans Regular',
							fontWeight: 600,
						}
					}
				],
				legend: {
					show: false,
					selected: {}
				},
				series: []
			},
			humiditySeries: [],
			lightOption: {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					backgroundColor: "#484E69",
					borderColor: "#484E69",
					textStyle: {
						color: 'white'
					},
				},
				grid: {
					left: '25%'
				},
				xAxis: [
					{
						type: 'time',
						axisLabel: {
							show: true,
							rotate: 90,
							textStyle: {
								color: 'white',
								fontSize: '12px',
								fontWeight: 200,
								fontFamily: 'Nunito Sans Light',
							}
						},
						axisLine: {
							lineStyle: {
								type: 'dashed'
							}
						},
						axisTick: {
							show: false
						}
					}
				],
				yAxis: [
					{
						type: 'value',
						show: true,
						nameRotate: 90,
						name: 'Light',
						nameLocation: 'middle',
						nameGap: 50,
						axisLabel: {
							show: true,
							color: 'white',
							// formatter: `{value} %`
						},
						splitLine: {
							lineStyle: {
								color: 'rgba(255, 255, 255, 0.3)',
								type: 'dashed',
								width: 1
							}
						},
						splitNumber: 8,
						nameTextStyle: {
							verticalAlign: 'middle',
							color: 'white',
							fontSize: '13px',
							fontFamily: 'Nunito Sans Regular',
							fontWeight: 600,
						}
					}
				],
				legend: {
					show: false,
					selected: {}
				},
				series: []
			},
			lightSeries: [],
			requestDay: new Date().toISOString().slice(0, 10),
			predictData: null
		}
	},
	watch: {
		async periodTime(newValue) {
			this.$nextTick(() => {
				this.lightOption.series = [];
				this.humidityOption.series = [];
				this.temperatureOption.series = [];
			});
			await this.getTemperatureData(this.periodTime, 'temperature');
			await this.getTemperatureData(this.periodTime, 'humidity');
			await this.getTemperatureData(this.periodTime, 'light');
			await this.getSensorTooltipData();
		},
		async defaultSiteId(newValue) {
			this.$nextTick(() => {
				this.lightOption.series = [];
				this.humidityOption.series = [];
				this.temperatureOption.series = [];
			});
			await this.getTemperatureData(this.periodTime, 'temperature');
			await this.getTemperatureData(this.periodTime, 'humidity');
			await this.getTemperatureData(this.periodTime, 'light');
			await this.getSensorTooltipData();
		}
	},
	async created() {
		// const response = await axios.get(`https://api.weatherstack.com/historical?access_key=a95e9d844b3ed5563ab65eae56709bfc&query=London&historical_date=${this.requestDay}&hourly=1`);
		// this.weatherData = response.data;
	},
	async mounted() {
		this.$nextTick(() => {
			this.lightOption.series = [];
			this.humidityOption.series = [];
			this.temperatureOption.series = [];
		});
		await this.getTemperatureData(this.periodTime, 'temperature');
		await this.getTemperatureData(this.periodTime, 'humidity');
		await this.getTemperatureData(this.periodTime, 'light');
		await this.getSensorTooltipData();
	},
	methods: {
		...mapActions({
			getData: 'influx/getInfluxData'
		}),
		downloadCSV() {
			let data = this.makeCSVData();
			this.getCSVfile(data);
		},
		async onDateRangeChange(value) {
			this.$nextTick(() => {
				this.lightOption.series = [];
				this.humidityOption.series = [];
				this.temperatureOption.series = [];
			});
			await this.getTemperatureData(value, 'temperature');
			await this.getTemperatureData(value, 'humidity');
			await this.getTemperatureData(value, 'light');
			await this.getSensorTooltipData();
		},
		getCSVfile(data) {
			const replacer = (key, value) => value === null ? '' : value;
			const header = Object.keys(data[0]);
			let csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
			csv.unshift(header.join(','));
			let csvArray = csv.join('\r\n');

			var blob = new Blob([csvArray], {type: 'text/csv' });
			let todayString = new Date().toISOString().slice(0,10);
			let name = 'Environment_download_' + todayString;
			saveAs(blob, `${name}.csv`);
		},
		getValueTime(value) {
			if (value.start !== null ) {
				return 	value.start + '-' + value.end
			} else {
				return '';
			}
		},
		async getSensorTooltipData() {
			for (let i = 0; i < this.lightOption.series.length; i++) {
				let lightValue = 0;
				this.lightOption.series[i].data.forEach(p => {
					lightValue += p[1];
				});
				lightValue = lightValue / this.lightOption.series[i].data.length;
				lightValue =  Math.round((lightValue + Number.EPSILON) * 100) / 100;

				let humidityValue = 0;
				this.humidityOption.series[i].data.forEach(p => {
					humidityValue += p[1];
				});
				humidityValue = humidityValue / this.humidityOption.series[i].data.length;
				humidityValue =  Math.round((humidityValue + Number.EPSILON) * 100) / 100;

				let temperatureValue = 0;
				let counter = 0;
				this.temperatureOption.series[i].data.forEach(p => {
					if (!!p[1]) {
						temperatureValue += p[1];
						counter++;
					}
				});
				temperatureValue = temperatureValue / counter;
				temperatureValue =  Math.round((temperatureValue + Number.EPSILON) * 100) / 100;

				if (!!this.sensorOption.series[0].data && this.sensorOption.series[0].data.length > 0) {
					this.sensorOption.series[0].data[i].light = lightValue;
					this.sensorOption.series[0].data[i].humi = humidityValue;
					this.sensorOption.series[0].data[i].temp = temperatureValue;
					Object.assign(this.sensorOption.series[0].data[i], {name: this.lightOption.series[i].name})
				}
			}
		},
		testGraph() {
			console.log(" change legend ");
			this.$nextTick(() => {
				this.temperatureOption.series = [];
				this.humidityOption.series = [];
				this.lightOption.series = [];
			});
		},

		changeLegendSelection(data) {
			if (data.hasOwnProperty('name')) {
				let newSeries = this.temperatureSeries.find(i => i.name === data.name);
				this.temperatureOption.series = [];
				this.temperatureOption.series.push(newSeries);
				this.$refs.temperatureChart.setOption(this.temperatureOption, true, true);

				newSeries = this.humiditySeries.find(i => i.name === data.name);
				this.humidityOption.series = [];
				this.humidityOption.series.push(newSeries);
				this.$refs.humidityChart.setOption(this.humidityOption, true, true);

				newSeries = this.lightSeries.find(i => i.name === data.name);
				this.lightOption.series = [];
				this.lightOption.series.push(newSeries);
				this.$refs.lightChart.setOption(this.lightOption, true, true);
			}
		},
		async getTemperatureData(value, type) {
			// this.isLoading = true;
			const query = this.getEnvironmentQuery(value, type);
			for (let i = 0; i < query.length; i++) {
				const envData = await this.getData(query[i].query);
				let data = [];
				envData.forEach(item => {
					data.push([
							item._time,
							item._value? parseFloat(item._value.toFixed(2)) : null
						]);
				});

				switch (type) {
					case 'temperature':
						this.temperatureOption.series.push({
							name: query[i].name,
							data: data,
							symbolSize: 0,
							type: 'line'
						});
						break;
					case 'humidity':
						this.humidityOption.series.push({
							name: query[i].name,
							data: data,
							symbolSize: 0,
							type: 'line'
						});
						break;
					case 'light':
						this.lightOption.series.push({
							name: query[i].name,
							data: data,
							symbolSize: 0,
							type: 'line'
						});
						break;
				}
			}

			switch (type) {
				case 'temperature':
					this.temperatureSeries = this.temperatureOption.series;
					break;
				case 'humidity':
					this.humiditySeries = this.humidityOption.series;
					break;
				case 'light':
					this.lightSeries = this.lightOption.series;
					break;
			}
		},
		getTimeValue(time) {
			let result = time;
			return result.slice(0, 10) + ' ' + result.slice(11, 16);
		},
		makeCSVData() {
			let csvJsonData = [];
			let timeKey = 'Local Time';
			for (let i = 0; i < this.lightOption.series[5].data.length; i++) {
				let csvObject = {};
				let timeValue = this.getTimeValue(this.lightOption.series[5].data[i][0]);
				Object.assign(csvObject, {[timeKey]: timeValue});
				for (let j = 0; j < this.lightOption.series.length; j++) {
					let temperatureKey = `${this.lightOption.series[j].name} Temperature`;
					let temperatureValue = this.temperatureOption.series[j].data[i][1];
					Object.assign(csvObject, {[temperatureKey]: temperatureValue});

					let humidityKey = `${this.lightOption.series[j].name} Humidity`;
					let humidityValue = this.humidityOption.series[j].data.length > 0?this.humidityOption.series[j].data[i][1] : 0;
					Object.assign(csvObject, {[humidityKey]: humidityValue});

					let lightKey = `${this.lightOption.series[j].name} Light`;
					let lightValue = this.lightOption.series[j].data[i][1];
					Object.assign(csvObject, {[lightKey]: lightValue});
				}
				csvJsonData.push(csvObject);
			}
			return csvJsonData;
		},
		openZoomDialog(type) {
			this.showModal = true;
			this.zoomOption.series = [];

			switch (type) {
				case 'temperature':
						this.zoomOption.yAxis[0].name = this.temperatureOption.yAxis[0].name;
						this.zoomOption.yAxis[0].axisLabel.formatter = this.temperatureOption.yAxis[0].axisLabel.formatter;
						this.zoomOption.series = this.temperatureOption.series;
					break;
				case 'humidity':
					this.$nextTick(() => {
						this.zoomOption.yAxis[0].name = this.humidityOption.yAxis[0].name;
						this.zoomOption.yAxis[0].axisLabel.formatter = this.humidityOption.yAxis[0].axisLabel.formatter;
						this.zoomOption.series = this.humidityOption.series;
					});
					break;
				case 'light':
					this.$nextTick(() => {
						this.zoomOption.yAxis[0].name = this.lightOption.yAxis[0].name;
						this.zoomOption.yAxis[0].axisLabel.formatter = this.lightOption.yAxis[0].axisLabel.formatter;
						this.zoomOption.series = this.lightOption.series;
					});
					break;
			}
		}
	},
};
</script>
<style lang="scss" scoped>
.zoomChart {
	width: 100%;
	height: 500px;
}
.image-wrapper{
	width: 100%;
	height: 465px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
	background-image: url("../../assets/img/floor-plan.png");
}
.sensor-chart {
	width: 1040px;
	height: 500px;
	margin: 0 auto;
}
.chart {
	height: 300px;
}
.graph-panel {
	cursor: pointer;
}

.close-icon {
	position: relative;
	top: 6px;
	left: 98%;
	cursor: pointer;
	font-size: 20px;
}

.display-time {
	width: 180px;
	height: 30px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	border-top-right-radius: 4px;
	border-bottom-right-radius: 4px;
	color: white;
}

.timepickerbutton {
	height: 30px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-top-left-radius: 4px;
	border-bottom-left-radius: 4px;
}

.filter-action {
	width: 180px;
	height: 30px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-radius: 4px;
	z-index: 8;
	&:hover, &.active {
		background-color: #1f5881;
	}
}
.w-title {
	font-size: 20px;
	color: white;
	font-weight: 200;
	font-family: "Nunito Sans Light";
	display: block;
	text-transform: uppercase;
	text-align: center;
}
.w-value {
	font-size: 20px;
	color: white;
	font-weight: 200;
	opacity: 0.9;
	font-family: "Nunito Sans Light";
	text-align: center;

}
</style>
